import { render, staticRenderFns } from "./products.vue?vue&type=template&id=5fd88b56&scoped=true&"
import script from "./products.vue?vue&type=script&lang=js&"
export * from "./products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd88b56",
  null
  
)

export default component.exports